import api from './api';

export type SubscriptionPlan = 'monthly' | 'semi_yearly' | 'yearly';

export type SubscriptionState = 'none' | 'active' | 'cancelled' | 'inactive' | 'past_due' | 'unpaid';

export interface SubscriptionResponse {
    sensors_count: number;
    state: SubscriptionState;
    has_access: boolean;
    status: string;
    plan: SubscriptionPlan;
    price_id: string;
    quantity: number;
    cancel_at_period_end: boolean;
    current_period_start: string;
    current_period_end: string;
    canceled_at: string | null;
}

export interface CheckoutRequest {
    plan: SubscriptionPlan;
}

export interface CheckoutResponse {
    session_id: string;
    url: string;
}

export interface PortalResponse {
    url: string;
}

export interface PlanDetails {
    id: string;
    unit_amount: number;
    currency: string;
    interval: string;
    interval_count: number;
}

export interface SubscriptionPlansResponse {
    plans: {
        monthly: PlanDetails;
        semi_yearly: PlanDetails;
        yearly: PlanDetails;
    };
}

export interface AddSensorsRequest {
    added_sensors: number;
    sensor_ids: (string | number)[];
}

export interface AddSensorsResponse {
    invoice_id: string;
    invoice_status: string;
    charged_amount: number;
    currency: string;
    days_left_in_period: number;
    per_sensor_month_price: number;
    prorate_factor: number;
    added_sensors: number;
    new_quantity: number;
}

export const subscriptionApi = {
    getSubscription: async (): Promise<SubscriptionResponse> => {
        const response = await api.get<SubscriptionResponse>('/api/v1/subscription');
        return response.data;
    },

    createCheckoutSession: async (plan: SubscriptionPlan): Promise<CheckoutResponse> => {
        const response = await api.post<CheckoutResponse>(
            '/api/v1/subscription/checkout',
            { plan },
        );
        return response.data;
    },

    getPortalUrl: async (): Promise<PortalResponse> => {
        const response = await api.post<PortalResponse>('/api/v1/subscription/portal');
        return response.data;
    },

    getPlans: async (): Promise<SubscriptionPlansResponse> => {
        const response = await api.get<SubscriptionPlansResponse>('/api/v1/subscription/plans');
        return response.data;
    },

    addSensors: async (sensor_ids: (string | number)[]): Promise<AddSensorsResponse> => {
        const response = await api.post<AddSensorsResponse>(
            '/api/v1/subscription/add-sensors',
            {
                added_sensors: sensor_ids.length,
                sensor_ids,
            },
        );
        return response.data;
    },
};
